module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main products home"
  }, [_c('div', {
    staticClass: "bannerBackground"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('p', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('title1')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#5ea2ec",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('title2')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "rgba(238, 238, 238, 0.8)",
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.$t('subtitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "get-start"
  }, [_c('div', {
    staticClass: "get-start-inner",
    style: ({
      'max-width': _vm.longTxt ? '565px' : '370px'
    })
  }, [_c('el-input', {
    class: _vm.inputStatus,
    style: ({
      'max-width': _vm.longTxt ? '565px' : '370px'
    }),
    attrs: {
      "placeholder": _vm.$t('placeholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.stopPropagation();
        _vm.getStart(true)
      }
    },
    model: {
      value: (_vm.startInput),
      callback: function($$v) {
        _vm.startInput = $$v
      },
      expression: "startInput"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInputErr),
      expression: "isInputErr"
    }],
    staticClass: "err-tips"
  }, [_c('img', {
    staticClass: "icon-prompt",
    attrs: {
      "src": require("../../assets/images/20181212/icon_prompt.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.errTipsTxt))])], 1), _vm._v(" "), _c('el-button', {
    style: ({
      'width': _vm.longTxt ? '180px' : '160px'
    }),
    on: {
      "click": function($event) {
        _vm.getStart(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('getstart')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "home-part crait-advantage"
  }, [_c('div', {
    staticClass: "home-info"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('contitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "home-crait-advantage-intro"
  }, [_c('li', [_c('p', {
    staticClass: "home-intro-title title"
  }, [_vm._v(_vm._s(_vm.$t('intro1-title')))]), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro1-detail')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_c('ul', {
    staticClass: "home-crait-advantage-intro secureCommunication"
  }, [_c('li', [_c('p', {
    staticClass: "home-intro-title title"
  }, [_vm._v(_vm._s(_vm.$t('intro2-title')))]), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro2-detail')))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "home-intro"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "home-crait-advantage-intro organization"
  }, [_c('li', [_c('p', {
    staticClass: "home-intro-title title"
  }, [_vm._v(_vm._s(_vm.$t('intro3-title')))]), _vm._v(" "), _c('p', {
    staticClass: "home-intro-detail"
  }, [_vm._v(_vm._s(_vm.$t('intro3-detail')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "home-part key-features"
  }, [_c('div', {
    staticClass: "home-info"
  }, [_c('p', {
    staticClass: "home-title title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-title')))])]), _vm._v(" "), _c('div', {
    staticClass: "home-intro key-feature-intro"
  }, [_c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list1')))])]), _vm._v(" "), _c('li', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list2')))])]), _vm._v(" "), _c('li', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list3')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "key-feature-lists"
  }, [_c('li', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list4')))])]), _vm._v(" "), _c('li', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list5')))])]), _vm._v(" "), _c('li', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "features-detail title"
  }, [_vm._v(_vm._s(_vm.$t('keyfeature-list6')))])])]), _vm._v(" "), _c('div', {
    staticClass: "learn-more cur"
  }, [_c('router-link', {
    attrs: {
      "to": "/Feature"
    }
  }, [_vm._v(_vm._s(_vm.$t('learnmore')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "home-part download"
  }, [_c('div', {
    staticClass: "large-screen"
  }, [_c('div', {
    staticClass: "bg-download"
  }, [_c('div', {
    staticClass: "get-start"
  }, [_c('div', {
    staticClass: "get-start-inner",
    style: ({
      'max-width': _vm.longTxt ? '645px' : '560px'
    })
  }, [_c('el-input', {
    class: _vm.inputStatus,
    style: ({
      'max-width': _vm.longTxt ? '645px' : '560px'
    }),
    attrs: {
      "placeholder": _vm.$t('placeholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.stopPropagation();
        _vm.getStart(true)
      }
    },
    model: {
      value: (_vm.startInput),
      callback: function($$v) {
        _vm.startInput = $$v
      },
      expression: "startInput"
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInputErr),
      expression: "isInputErr"
    }],
    staticClass: "err-tips"
  }, [_c('img', {
    staticClass: "icon-prompt",
    attrs: {
      "src": require("../../assets/images/20181212/icon_prompt.png"),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.errTipsTxt))])], 1), _vm._v(" "), _c('el-button', {
    style: ({
      'width': _vm.longTxt ? '300px' : '240px'
    }),
    on: {
      "click": function($event) {
        _vm.getStart(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('getstart')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "get-app"
  }, [_vm._v(_vm._s(_vm.$t('download-getApp')) + "\n            "), _c('u', {
    ref: "dlIphone",
    on: {
      "mouseenter": function($event) {
        _vm.showQrCode('iphone')
      },
      "mouseleave": _vm.hideQrCode
    }
  }, [_vm._v(_vm._s(_vm.$t('download-iphone')))]), _vm._v(" , \n            "), _c('u', {
    ref: "dlGphone",
    on: {
      "mouseenter": function($event) {
        _vm.showQrCode('gphone')
      },
      "mouseleave": _vm.hideQrCode
    }
  }, [_vm._v(_vm._s(_vm.$t('download-gphone')))]), _vm._v(" , \n            "), _c('u', [_vm._v(_vm._s(_vm.$t('download-pc')))]), _vm._v(" , \n            "), _c('u', [_vm._v(_vm._s(_vm.$t('download-chrome')))]), _vm._v(" "), _c('div', {
    ref: "qrCodeBox",
    staticClass: "qr-code-box",
    style: ({
      top: _vm.qrCodeBox.top,
      left: _vm.qrCodeBox.left,
      visibility: _vm.qrCodeBox.show
    })
  }, [_c('img', {
    staticClass: "qr-code",
    attrs: {
      "src": require("../../assets/images/20181212/qr_code.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('download-scanCode')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('download-dlApp')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "small-screen"
  }, [_c('div', {
    staticClass: "bg-download"
  }, [_c('p', {
    staticClass: "dl-title"
  }, [_vm._v(_vm._s(_vm.$t('download-title-m')))]), _vm._v(" "), _c('div', {
    staticClass: "dl-btn",
    on: {
      "click": _vm.getStart
    }
  }, [_vm._v(_vm._s(_vm.$t('download-dl-btn')))])])])])]), _vm._v(" "), _c('wx-mask', {
    attrs: {
      "maskShow": _vm.showWxMask
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/collaboration_pic@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/communication_pic@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-pic"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/organization_pic@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_chat@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_voicecalls@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_sharing@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_synced@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_vioce@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/20180102/keyfeature_clouddrive@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b098af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 300
// module chunks = 1